<template>
  <v-overlay :value="Overlay.value" :z-index="999">
    <v-row justify="center" align="center">
      <v-col cols="auto" class="py-0">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
      <v-col cols="12" class="py-0">
        <h5 class="text-center">{{ Overlay.title }}</h5>
      </v-col>
    </v-row>
  </v-overlay>
</template>

<script>
export default {
  computed: {
    Overlay() {
      return this.$store.getters["layout/OVERLAY_VALUE"];
    },
  },
};
</script>

<style></style>
